export default __webpack_public_path__ + "images/GS.abfbfa9.png";